import React, { forwardRef } from "react";

const CardBox = forwardRef(({ children, additionalclasses }, ref) => {
  return (
    <div
      ref={ref}
      className={`grid custom-bg-white-50   rounded-lg p-4 ${additionalclasses}`}
    >
      {children}
    </div>
  );
});

// Setting a display name for debugging purposes
CardBox.displayName = "CardBox";

export default CardBox;
